(function () {
  const root = document.querySelector('[data-sas-gallery-section]');
  if (!root) return;

  const autoplayEnabled = root.dataset.sasAutoplay === 'true';
  const mainItems = Array.from(root.querySelectorAll('[data-sas-video-main-item]'));
  const thumbs = Array.from(root.querySelectorAll('[data-sas-thumb]'));
  const thumbsWrap = root.querySelector('[data-sas-thumbs]');
  const prevBtn = root.querySelector('[data-sas-prev]');
  const nextBtn = root.querySelector('[data-sas-next]');

  function pauseAllVideos() {
    mainItems.forEach((item) => {
      const video = item.querySelector('video');
      if (video && !video.paused) video.pause();  
    });
  }

  function setActive(blockId, { autoplay = true, muted = false } = {}) {
    const targetMain = mainItems.find((x) => x.dataset.sasBlockId === blockId);
    if (!targetMain) return;

    mainItems.forEach((x) => x.classList.toggle('is-active', x === targetMain));
    thumbs.forEach((thumb) => {
      const isActive = thumb.dataset.sasTargetId === blockId;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-sas-current', isActive ? 'true' : 'false');
    });

    pauseAllVideos();
    const video = targetMain.querySelector('video');
    if (video && autoplay) {
      video.currentTime = 0;
      video.muted = muted;
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }

    const activeThumb = thumbs.find((t) => t.dataset.sasTargetId === blockId);
    if (activeThumb) {
      activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  thumbs.forEach((btn) => {
    btn.addEventListener('click', () => setActive(btn.dataset.sasTargetId, { autoplay: true }));
  });

  const scrollByAmount = () => {
    if (!thumbsWrap) return 0;
    const first = thumbsWrap.querySelector('.sas__thumb');
    return first ? first.getBoundingClientRect().width + 12 : 240;
  };

  if (prevBtn && thumbsWrap) {
    prevBtn.addEventListener('click', () => {
      thumbsWrap.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
    });
  }

  if (nextBtn && thumbsWrap) {
    nextBtn.addEventListener('click', () => {
      thumbsWrap.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
    });
  }

  const first = thumbs[0]?.dataset.sasTargetId;
  if (first) {
    setActive(first, { autoplay: false });

    if (autoplayEnabled) {
      const triggerAutoplay = () => setActive(first, { autoplay: true, muted: true });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              triggerAutoplay();
              observer.disconnect();
            }
          });
        }, { rootMargin: '0px 0px 200px 0px' });
        observer.observe(root);
      } else {
        triggerAutoplay();
      }
    }
  }
})();
